<script setup lang="ts">
import type { PdpEcommerceBlockAccordionProps } from './PdpEcommerceBlockAccordion.props'

defineProps<PdpEcommerceBlockAccordionProps>()

const isOpen = defineModel<boolean>('open', { default: false })

const slots = useSlots()
const hasBody = computed(() => !!slots.default)
</script>

<template>
  <div v-if="hasBody" class="w-full">
    <button
      type="button"
      class="flex w-full items-center justify-between py-2 text-left"
      :aria-expanded="isOpen"
      @click="isOpen = !isOpen"
    >
      <span class="text-medium-6">{{ label }}</span>
      <DefaultIconsChevronDown
        class="size-5 shrink-0 transition-transform duration-300"
        :class="{ 'rotate-180': isOpen }"
        aria-hidden="true"
      />
    </button>

    <HeadlessTransitionRoot
      :show="isOpen"
      enter="transition-all duration-300 overflow-hidden"
      enter-from="max-h-0 opacity-0"
      enter-to="max-h-screen opacity-100"
      leave="transition-all duration-300 overflow-hidden"
      leave-from="max-h-screen opacity-100"
      leave-to="max-h-0 opacity-0"
    >
      <div class="pb-4">
        <slot />
      </div>
    </HeadlessTransitionRoot>
  </div>
</template>
